import { render, staticRenderFns } from "./openAdminNewTab.vue?vue&type=template&id=1be587bb&"
import script from "./openAdminNewTab.vue?vue&type=script&lang=js&"
export * from "./openAdminNewTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports